import { FC } from 'react';
import Column from 'components/Column';
import { Link } from 'components/Link';
import { Body } from 'components/Typography';
import { StyledImage } from './styled';
import ellipseImage from '../../assets/images/ellipse.png';

interface Props {
  text: string;
  image?: string;
  onPress?: () => void;
}

export const EllipseText: FC<Props> = ({ text, onPress, image }) => {
  return (
    <Column $width="100%" $textAlign="center">
      <StyledImage alt="ellipse" src={image || ellipseImage} />
      {onPress ? (
        <Link onClick={onPress} $textAlign="center" $fontSize="15px">
          {text}
        </Link>
      ) : (
        <Body $fontType="regular">{text}</Body>
      )}
    </Column>
  );
};
